<template>
  <nna-container>
    <div class="">
      <h1 class="md-title">{{title}}</h1>      
      <p>{{copy}}</p>
    </div>
  </nna-container>  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Terms',
  computed: {
    copy() {
      return this.$route.params.page.copy ? this.$route.params.page.copy : ''
    },
    title() {
      return this.$route.params.page.title ? this.$route.params.page.title : ''
    }    
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/modules/terms/pages/Terms.vue